import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import RMMILandedCostTable from "./RMMILandedCostTable";
import btnDownloadIcon from "../../../Assests/download-icon.svg";
import btnSaveIcon from "../../../Assests/Save-btn.svg";
import {
  EditProductTableSuccess,
  ViewProductTableError,
  ViewProductTableStart,
  ViewProductTableSuccess,
  enableEditFilter,
  loadCascadeOptions,
} from "../../../Redux/Actions/InputData";
import { postRequest, putRequest } from "../../../Services/AxiosConfiguration";
import {
  API_BASE_URL,
  BULK_EDIT_MANUFACTURING_MASTER_TABLE_API,
  DISPLAY_MANUFACTURING_MASTER_1_TABLE_API,
  DOWNLOAD_MANUFACTURING_MASTER_1_TABLE_API,
  LONG_CASCADE_MASTER_DOWNLOAD_API,
  LONG_CASCADE_MASTER_GET_API,
  LONG_CASCADE_UPDATE_DATA_API,
  LONG_FACILITY_MASTER_GET_API,
  LONG_UPDATE_BULK_EDIT_PMMILANDEDCOST_API,
  LT_PMMILANDEDCOST_MODULE2,
  LT_PMMILANDEDCOST_MODULE2_DOWNLOAD,
  VIEW_MANUFACTURING_MASTER_1_TABLE_API,
} from "../../../Utils/Config";
import RestoreOutlinedIcon from "@mui/icons-material/RestoreOutlined";
import axios from "axios";
import FileSaver from "file-saver";
import "./style.css";
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import Snackbar from "@mui/material/Snackbar";
import Alert, { AlertProps } from "@mui/material/Alert";
import AddRowButton from "../../../Components/Common/AddRowButton";
import DeleteRowsButton from "../../../Components/Common/DeleteRowsButton";
import ConfirmationDialog from "../../../Components/Common/ConfirmationDialog";

function RMMILandedCost(props: any) {
  const childRef: any = useRef();
  const dispatch: any = useDispatch();
  const [selectPlantDescription, setSelectPlantDescription] = useState<any>("");
  const [selectPlantCode, setSelectPlantCode] = useState<any>("");
  const [selectSFGCode, setSelectSFGCode] = useState<any>("");
  const [selectFGCode, setSelectFGCode] = useState<any>("");
  const [rowsData, setRows] = React.useState<any[]>([]);
  const [isProcessed, setIsProcessed] = React.useState(false);
  const [facilityCodeOptions, setFacilityCodeOptions] = React.useState([]);
  const [packagingCodeOptions, setPackagingCodeOptions] = useState<any>([]);
  const [timeOptions, setTimeOptions] = useState<any>([]);
  const [selectTime, setSelectTime] = useState<any>("");
  const [sfgCodeOptions, setSFGCodeOptions] = useState<any>([]);
  const [FGCodeOptions, setFGCodeOptions] = useState<any>([]);
  const [getEditedValue, setEditedValue] = useState<any>([]);
  const [open, setOpen] = React.useState(false);

  const [filterRequest, setFilterRequest] = React.useState([
    { key: "packaging_Plant_Code", value: "" },
    { key: "packaging_Plant_Description", value: "" },
    { key: "fG_Code", value: "" },
    { key: "sfG_PM_Code", value: "" },
    { key: "time_Period", value: "" },
  ]);

  const facilityCodeNames = facilityCodeOptions?.sort((a: any, b: any) =>
    a?.packaging_Plant_Description.localeCompare(
      b?.packaging_Plant_Description,
    ),
  );

  const FGCodeNames = FGCodeOptions?.sort((a: any, b: any) =>
    a?.fG_Code.localeCompare(b?.fG_Code),
  );

  var code = 0;
  var description = 0;
  var fgCode = 0;
  var sfgCode = 0;
  var time = 0;

  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId,
  );

  const selectedScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedScenarioId,
  );

  const isEditPopup = useSelector(
    (state: any) => state.InputDataReducers.editPopupFlage,
  );

  const selectedTimePeriodData = useSelector(
    (state: any) => state.InputDataReducers.selectedTimePeriodData,
  );
  const selectedFolderData = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderData,
  );

  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId,
  );
  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId,
  );

  let folderModuleName = selectedFolderData?.folder?.slice(0, 7);
  const [tableName, setTableName] = useState<any>(
    "tblScenario_PMMILandedCost_LT",
  );

  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [deletedRows, setDeletedRows] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [isActionEnabled, setIsActionEnabled] = useState(false);
  const handleSelectionChange = (newSelection: any[]) => {
    setSelectedRows(newSelection);
    setIsActionEnabled(newSelection.length > 0);
  };

  useEffect(() => {
    if (folderModuleName === "module2") {
      setTableName("tblScenario_PMMILandedCost_LT_Module2");
      getfiltersApi("tblScenario_PMMILandedCost_LT_Module2");
    } else if (folderModuleName === "module3") {
      setTableName("tblScenario_PMMILandedCost_LT_Module3");
      getfiltersApi("tblScenario_PMMILandedCost_LT_Module3");
    } else if (folderModuleName === "module4") {
      setTableName("tblScenario_PMMILandedCost_LT_Module4");
      getfiltersApi("tblScenario_PMMILandedCost_LT_Module4");
    } else if (folderModuleName === "module5") {
      setTableName("tblScenario_PMMILandedCost_LT_Module5");
      getfiltersApi("tblScenario_PMMILandedCost_LT_Module5");
    } else if (folderModuleName === "module6") {
      setTableName("tblScenario_PMMILandedCost_LT_Module6");
      getfiltersApi("tblScenario_PMMILandedCost_LT_Module6");
    } else {
      setTableName("tblScenario_PMMILandedCost_LT");
      getfiltersApi("tblScenario_PMMILandedCost_LT");
    }
  }, [folderModuleName, selectedScenarioId]);

  const handleChangeSelectPlantDescription = (event: any) => {
    setSelectFGCode("");
    setSelectTime("");
    setSelectSFGCode("");
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    const {
      target: { value },
    } = event;
    setSelectPlantDescription(value);
    filterRequest[1].value = value;
    callTableGridApi();
    code = 1;
    description = 1;
    fgCode = 0;
    sfgCode = 0;
    time = 0;
  };

  const handleChangeSelectSFGCode = (event: any) => {
    setSelectTime("");
    const {
      target: { value },
    } = event;
    setSelectSFGCode(value);
    filterRequest[3].value = value;
    filterRequest[4].value = "";
    callTableGridApi();
    code = 1;
    description = 1;
    fgCode = 1;
    sfgCode = 1;
    time = 0;
  };

  const handleChangeFGCode = (event: any) => {
    setSelectSFGCode("");
    setSelectTime("");
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    const {
      target: { value },
    } = event;
    setSelectFGCode(value);
    filterRequest[2].value = value;
    callTableGridApi();
    code = 1;
    description = 0;
    fgCode = 1;
    sfgCode = 0;
    time = 0;
  };

  const handleChangeSelectPlantCode = (event: any) => {
    setSelectFGCode("");
    setSelectPlantDescription("");
    setSelectTime("");
    setSelectSFGCode("");
    filterRequest[1].value = "";
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    const {
      target: { value },
    } = event;
    setSelectPlantCode(value);
    filterRequest[0].value = value;
    callTableGridApi();
    code = 1;
    description = 0;
    fgCode = 0;
    sfgCode = 0;
    time = 0;
  };

  const handleChangeSelectTime = (event: any) => {
    const {
      target: { value },
    } = event;
    setSelectTime(value);
    filterRequest[4].value = value;
    callTableGridApi();
    code = 1;
    description = 1;
    fgCode = 1;
    sfgCode = 1;
    time = 1;
  };

  const handleDownload = (e: any) => {
    downloadXLSFile();
  };

  const downloadXLSFile = async () => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    const requestParam = {
      usecaseId: 0,
      category_id: 0,
      folder_id: selectedFolderId,
      scenario_id: selectedScenarioId,
      table: tableName,
      time_period: "string",
      filter: filterList,
    };
    // const requestParam = { "folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblManufacturing1Data", "filter": filterList };
    const urls = API_BASE_URL + LT_PMMILANDEDCOST_MODULE2_DOWNLOAD;
    axios({
      url: urls,
      method: "post",
      responseType: "arraybuffer",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver(blob, Date.now() + ".xlsx");
    });
  };

  useEffect(() => {
    callTableGridApi();
  }, [
    selectedUsecaseId,
    selectedCategoryId,
    selectedFolderId,
    selectedScenarioId,
    selectedTimePeriodData,
  ]);
  const callTableGridApi = (resetfilter?: any) => {
    let timePeriodValues =
      selectedTimePeriodData !== undefined &&
      selectedTimePeriodData &&
      selectedTimePeriodData !== "Time Period" &&
      selectedTimePeriodData?.length > 0 &&
      selectedTimePeriodData[0] !== "Time Period" &&
      selectedTimePeriodData !== ""
        ? selectedTimePeriodData.join(",")
        : "";
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    console.log(selectedScenarioId, "scenario2");
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId
        : selectedScenarioId;
    const requestParam = {
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      table: tableName,
      ispagination: 1,
      page: 1,
      pagesize: 100,
      filter: filterList,
      time_period: timePeriodValues,
    };

    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + LT_PMMILANDEDCOST_MODULE2;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          setIsProcessed(true);

          setRows(response.data);
          if (sfgCode === 0) {
            setSFGCodeOptions(loadSFGCodeOptions(response.data));
          }
          if (description === 0) {
            setFacilityCodeOptions(loadFacilityCodeOptions(response.data));
          }
          if (fgCode === 0) {
            setFGCodeOptions(loadFGCodeOptions(response.data));
          }
          if (code === 0) {
            setPackagingCodeOptions(loadPackagingCodeOptions(response.data));
          }
          if (time === 0) {
            setTimeOptions(loadTimeOptions(response.data));
          }
          dispatch(ViewProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  const loadFacilityCodeOptions = (data: any) => {
    const facilityCodeOptions: any = [];
    data.map((item: any) => {
      const filteredItem = facilityCodeOptions.find((obj: any) => {
        return (
          obj.packaging_Plant_Description === item.packaging_Plant_Description
        );
      });
      if (filteredItem === undefined || filteredItem == null) {
        facilityCodeOptions.push({
          id: item.id,
          packaging_Plant_Description: item.packaging_Plant_Description,
        });
      }
    });
    return facilityCodeOptions;
    //setFacilityCodeOptions(factoryOptions);
  };

  const loadFGCodeOptions = (data: any) => {
    const FGCodeOptions: any = [];
    data.map((item: any) => {
      const filteredItem = FGCodeOptions.find((obj: any) => {
        return obj.fG_Code === item.fG_Code;
      });
      if (filteredItem === undefined || filteredItem == null) {
        FGCodeOptions.push({ id: item.id, fG_Code: item.fG_Code });
      }
    });
    return FGCodeOptions;
    //setFacilityCodeOptions(factoryOptions);
  };

  const loadSFGCodeOptions = (data: any) => {
    const SFGCodeOptions: any = [];
    data.map((item: any) => {
      const filteredItem = SFGCodeOptions.find((obj: any) => {
        return obj.sfG_PM_Code === item.sfG_PM_Code;
      });
      if (filteredItem === undefined || filteredItem == null) {
        SFGCodeOptions.push({ id: item.id, sfG_PM_Code: item.sfG_PM_Code });
      }
    });
    return SFGCodeOptions;
    //setFacilityCodeOptions(factoryOptions);
  };

  const loadPackagingCodeOptions = (data: any) => {
    console.log(data, "basepack");
    const packagingCodeOptions: any = [];
    data.map((item: any) => {
      const filteredItem = packagingCodeOptions.find((obj: any) => {
        return obj.packaging_Plant_Code === item.packaging_Plant_Code;
      });
      if (filteredItem === undefined || filteredItem == null) {
        packagingCodeOptions.push({
          id: item.id,
          packaging_Plant_Code: item.packaging_Plant_Code,
        });
      }
    });
    return packagingCodeOptions;
  };

  const loadTimeOptions = (data: any) => {
    const timeOptions: any = [];
    data.map((item: any) => {
      const filteredItem = timeOptions.find((obj: any) => {
        return obj.time_Period === item.time_Period;
      });
      if (filteredItem === undefined || filteredItem == null) {
        timeOptions.push({ id: item.id, time_Period: item.time_Period });
      }
    });
    return timeOptions;
  };

  const getfiltersApi = (tableeName?: string) => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId?.scenario_id
        : selectedScenarioId;
    const requestParam = {
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      table: tableeName ?? tableName,
      ispagination: 1,
      page: 1,
      pagesize: 100,
      filter: filterList,
      time_period: "",
    };

    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + LT_PMMILANDEDCOST_MODULE2;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          console.log(response.data, "response");
          setIsProcessed(true);
          setRows(response.data);
          setFacilityCodeOptions(loadFacilityCodeOptions(response.data));
          setPackagingCodeOptions(loadPackagingCodeOptions(response.data));
          setTimeOptions(loadTimeOptions(response.data));
          setSFGCodeOptions(loadSFGCodeOptions(response.data));
          setFGCodeOptions(loadFGCodeOptions(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  const handleRestoreClicked = (e: any) => {
    setSelectPlantDescription("");
    setSelectPlantCode("");
    setSelectTime("");
    setSelectSFGCode("");
    setSelectFGCode("");

    // getfiltersApi();
    filterRequest[0].value = "";
    filterRequest[1].value = "";
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    callTableGridApi(tableName);
  };

  // bulk edit

  const handleClearEditData = (val: any) => {
    console.log(val, "edited array");
  };

  const isEditEnabled = useSelector(
    (state: any) => state.InputDataReducers.editFilterEnable,
  );

  const handleFetchEditData = (val: any) => {
    console.log(val, "edited array");
    setEditedValue(val);
  };

  const handleEditSave = (e: any) => {
    const requiredFields = [
      "factory_Code",
      "factory",
      "cascade",
      "line",
      "max_no_of_shifts",
      "max_no_of_changeovers",
      "changeover_Shift",
    ];
    const allMissingFields = new Set<string>();
    getEditedValue.forEach((row: any) => {
      requiredFields.forEach((field) => {
        const value = row[field];
        if (value === undefined || value === null || value === "") {
          // Convert field name to readable format
          const fieldName = field
            .replace(/_/g, " ")
            .replace(/\b\w/g, (l) => l.toUpperCase());
          allMissingFields.add(fieldName);
        }
      });
    });

    if (allMissingFields.size > 0) {
      // Convert Set to Array and join
      const missingFieldsList = Array.from(allMissingFields).join(", ");

      setSnackbar({
        children: `Please fill the required fields: ${missingFieldsList}`,
        severity: "error",
      });
      return; // Prevent the save operation
    }

    handleClickOpen();
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAddRow = () => {
    setRows((prev: any) => {
      const emptyRow = {
        id: new Date().getTime(),
        folder_id: selectedFolderId,
        scenario_id: selectedScenarioId,
        processing_Plant_Code: "",
        processing_Plant_Description: "",
        fG_Code: "",
        sfG_PM_Code: "",
        time_Period: "",
        mipM_Landed_Cost: 0,
      };
      return prev.length > 0 ? [...prev, emptyRow] : prev;
    });
  };
  //const urls = API_BASE_URL + BULK_EDIT_MANUFACTURING_MASTER_TABLE_API;

  const handleDeleteRows = () => {
    if (!selectedRows.length) return;
    setIsDeleteConfirmOpen(true);
  };

  const handleConfirmDeleteRows = () => {
    const updatedRows: any[] = [];
    const rowsToDelete: any[] = [];

    rowsData.forEach((row: any) => {
      if (selectedRows.includes(row.id)) {
        const updated = {
          ...row,
          folder_id: 0,
          folder_Id: 0,
          scenario_id: 0,
          isDelete: true,
        };
        rowsToDelete.push(updated);
      } else {
        updatedRows.push(row);
      }
    });

    setRows(updatedRows);

    if (rowsToDelete.length > 0) {
      // Store deleted rows separately
      setDeletedRows((prev: any[]) => [...prev, ...rowsToDelete]);

      setIsDeleteConfirmOpen(false);
      setSelectedRows([]);
      setIsActionEnabled(false);

      const dataToSave =
        getEditedValue && getEditedValue.length > 0
          ? [
              ...getEditedValue.filter(
                (row: any) => row && Object.keys(row).length > 0,
              ),
              ...rowsToDelete,
            ]
          : rowsToDelete;

      handleAgree(dataToSave, "Record deleted successfully");
    } else {
      setIsDeleteConfirmOpen(false);
    }
  };

  const handleAgree = (dataToSave: any[], successMessage: string) => {
    const transformedRows = dataToSave.map((row: any) => {
      if (row.isNew) {
        const { isNew, ...rest } = row;
        rest.id = 0;
        return rest;
      } else if (row.isDelete) {
        const { isDelete, ...rest } = row;
        rest.folder_id = 0;
        rest.Scenario_Id = 0;
        return rest;
      }

      return row;
    });
    const urls = API_BASE_URL + LONG_UPDATE_BULK_EDIT_PMMILANDEDCOST_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    const payload = {
      moduleKey: Number(folderModuleName.slice(-1)),
      data: transformedRows,
    };

    putRequest(urls, payload, header, {})
      .then((response) => {
        if (response.status == 200) {
          callTableGridApi();
          setSnackbar({
            children: successMessage,
            severity: "success",
          });
          handleClose();
          childRef?.current?.ClearEditedData();
          dispatch(EditProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        setSnackbar({
          children: "Something went wrong please try again!",
          severity: "error",
        });
        handleClose();
      });
  };

  // bulk edit

  const [snackbar, setSnackbar] = React.useState<Pick<
    AlertProps,
    "children" | "severity"
  > | null>(null);

  const handleCloseSnackbar = () => setSnackbar(null);

  return (
    <>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        className="Dialogbox-display"
      >
        <DialogTitle
          id="responsive-dialog-title"
          className="responsive-dialog-title-txt"
        >
          {"Confirmation for Edit"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText className="md-alert-clr">
            {getEditedValue.length > 0
              ? "Do you want to submit the edited RMMILandedCost table data?"
              : "Please Edit any value to save!"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {getEditedValue.length > 0 ? (
            <>
              <Button className="modal-btn-b" autoFocus onClick={handleClose}>
                No
              </Button>
              <Button
                className="modal-btn-b"
                onClick={() =>
                  handleAgree(getEditedValue, "Successfully saved")
                }
                autoFocus
              >
                Yes
              </Button>
            </>
          ) : (
            <Button className="modal-btn-b" autoFocus onClick={handleClose}>
              Ok
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <ConfirmationDialog
        open={isDeleteConfirmOpen}
        onClose={() => setIsDeleteConfirmOpen(false)}
        onConfirm={handleConfirmDeleteRows}
        title="Confirmation for Delete"
        page="Shift And Changeover"
        confirmText="Yes"
        cancelText="No"
        fullScreen={fullScreen}
      />
      <div className="Compare">
        <div className="filter-section">
          <div className="page-title">
            <h3>PMMI Landed Cost</h3>
          </div>
          <div className="filters">
            <span title="Reset">
              <RestoreOutlinedIcon
                className="restoreIcon"
                onClick={(e) => handleRestoreClicked(e)}
              />
            </span>
            <AddRowButton
              isEditEnabled={isEditEnabled && !isActionEnabled}
              handleAddRow={handleAddRow}
            />
            <DeleteRowsButton
              isEditEnabled={isEditEnabled && isActionEnabled}
              handleDeleteRows={handleDeleteRows}
            />
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown ddoverlap-fix">
                <Select
                  id="simple-select-4"
                  value={selectPlantCode}
                  placeholder="Select Basepack"
                  onChange={handleChangeSelectPlantCode}
                  // renderValue={(selectPlantCode: any) => selectPlantCode}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Packaging Plant Code</em>
                  </MenuItem>
                  {packagingCodeOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.packaging_Plant_Code}>
                        {d.packaging_Plant_Code}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown ddoverlap-fix">
                {/* <InputLabel>Facility Code</InputLabel> */}
                {/* <InputLabel>Cascade</InputLabel> */}
                <Select
                  id="simple-select-1"
                  value={selectPlantDescription}
                  placeholder="Select Factory"
                  onChange={handleChangeSelectPlantDescription}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Packaging Plant Description</em>
                  </MenuItem>
                  {facilityCodeNames?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.packaging_Plant_Description}>
                        {d.packaging_Plant_Description}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown ddoverlap-fix">
                {/* <InputLabel>Facility Description</InputLabel> */}
                <Select
                  id="simple-select-3"
                  value={selectFGCode}
                  placeholder="Select Line"
                  onChange={handleChangeFGCode}
                  // renderValue={(selectFGCode: any) => selectFGCode}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>FG Code</em>
                  </MenuItem>
                  {FGCodeNames?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.fG_Code}>
                        {d.fG_Code}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown ddoverlap-fix">
                {/* <InputLabel>Cascade</InputLabel> */}
                {/* <InputLabel>Facility Type</InputLabel> */}
                <Select
                  id="simple-select-2"
                  value={selectSFGCode}
                  placeholder="Select Cascade"
                  onChange={handleChangeSelectSFGCode}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>SFG PM Code</em>
                  </MenuItem>
                  {sfgCodeOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.sfG_PM_Code}>
                        {d.sfG_PM_Code}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>

            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown ddoverlap-fix">
                {/* <InputLabel>Flag</InputLabel> */}
                <Select
                  id="simple-select-4"
                  value={selectTime}
                  placeholder="Select Basepack"
                  onChange={handleChangeSelectTime}
                  // renderValue={(selectTime: any) => selectTime}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Time Period</em>
                  </MenuItem>
                  {timeOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.time_Period}>
                        {d.time_Period}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            {isEditEnabled && isEditPopup && (
              <FormControl fullWidth>
                <div
                  className="content-save-btn"
                  onClick={(e) => handleEditSave(e)}
                >
                  <img src={btnSaveIcon} alt="" /> <span> Save</span>
                </div>
              </FormControl>
            )}

            <div className="filter-item">
              <FormControl fullWidth>
                <div
                  className={`content-download-btn ${
                    isActionEnabled ? "disabled" : ""
                  }`}
                  onClick={(e) => handleDownload(e)}
                >
                  <img src={btnDownloadIcon} alt="" /> <span> Download</span>
                </div>
              </FormControl>
            </div>
          </div>
        </div>
      </div>
      <div>
        <RMMILandedCostTable
          ref={childRef}
          isProcessed={isProcessed}
          rowsData={rowsData}
          handleGetEditData={handleFetchEditData}
          handleClearEditData={handleClearEditData}
          setRows={setRows}
          handleSelectionChange={handleSelectionChange}
          selectedRows={selectedRows}
        />
        {!!snackbar && (
          <Snackbar
            open
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={handleCloseSnackbar}
            autoHideDuration={6000}
          >
            <Alert {...snackbar} onClose={handleCloseSnackbar} />
          </Snackbar>
        )}
      </div>
    </>
  );
}

export default RMMILandedCost;
